import defaultOptions from './defaultoption'
import jwt from 'jsonwebtoken'
import * as auth from './auth/auth'
import axios from 'axios'

const pedidos = {
  async cotacao(
    OpcaoFiltro,
    Numero,
    DataInicial,
    DataFinal,
    Page = 1,
    PageSize = 10
  ) {
    let page = !!Page ? `Page=${Page}` : ''
    let pagesize = !!PageSize ? `&PageSize=${PageSize}` : ''
    let opcaofiltro = !!OpcaoFiltro ? `&OpcaoFiltro=${OpcaoFiltro}` : ''
    let numero = !!Numero ? `&Numero=${Numero}` : ''
    let datainicial = !!DataInicial
      ? `&DataInicial=${DataInicial.replace('/', '%2F')}`
      : ''
    let datafinal = !!DataFinal
      ? `&DataFinal=${DataFinal.replace('/', '%2F')}`
      : ''

    return await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}pedidos/api/cotacao?${page}${pagesize}${opcaofiltro}${numero}${datainicial}${datafinal}`,
      {
        method: 'get',
        headers: defaultOptions.headers
      }
    )
  },

  async negociacao(
    OpcaoFiltro,
    Numero,
    DataInicial,
    DataFinal,
    Page = 1,
    PageSize = 10
  ) {
    let page = !!Page ? `Page=${Page}` : ''
    let pagesize = !!PageSize ? `&PageSize=${PageSize}` : ''
    let opcaofiltro = !!OpcaoFiltro ? `&OpcaoFiltro=${OpcaoFiltro}` : ''
    let numero = !!Numero ? `&Numero=${Numero}` : ''
    let datainicial = !!DataInicial
      ? `&DataInicial=${DataInicial.replace('/', '%2F')}`
      : ''
    let datafinal = !!DataFinal
      ? `&DataFinal=${DataFinal.replace('/', '%2F')}`
      : ''

    return await fetch(
      `${process.env.REACT_APP_API_PEDIDOS}api/negociacao?${page}${pagesize}${opcaofiltro}${numero}${datainicial}${datafinal}`,
      {
        method: 'get',
        headers: defaultOptions.headers
      }
    )
  },

  async pedido(
    IdStatus,
    IdPedido,
    DataInicial,
    DataFinal,
    Page = 1,
    PageSize = 10
  ) {
    let page = !!Page ? `Page=${Page}` : ''
    let pagesize = !!PageSize ? `&PageSize=${PageSize}` : ''
    let idStatus = !!IdStatus ? `&IdStatus=${IdStatus}` : ''
    let idPedido = !!IdPedido ? `&IdPedido=${IdPedido}` : ''
    let datainicial = !!DataInicial
      ? `&DataInicial=${DataInicial.replace('/', '%2F')}`
      : ''
    let datafinal = !!DataFinal
      ? `&DataFinal=${DataFinal.replace('/', '%2F')}`
      : ''

    return await fetch(
      `${process.env.REACT_APP_API_PEDIDOS}api/pedidos?${page}${pagesize}${idStatus}${idPedido}${datainicial}${datafinal}`,
      {
        method: 'get',
        headers: defaultOptions.headers
      }
    )
  },

  async vendaPromovida(
    CodigoPromotor,
    IdPedido,
    DataInicial,
    DataFinal,
    Page = 1,
    PageSize = 10
  ) {
    let page = !!Page ? `&Page=${Page}` : ''
    let pagesize = !!PageSize ? `&PageSize=${PageSize}` : ''
    let codigoPromotor = !!CodigoPromotor
      ? `CodigoPromotor=${CodigoPromotor}`
      : ''
    let idPedido = !!IdPedido ? `&IdPedido=${IdPedido}` : ''
    let datainicial = !!DataInicial
      ? `&DataInicial=${DataInicial.replace('/', '%2F')}`
      : ''
    let datafinal = !!DataFinal
      ? `&DataFinal=${DataFinal.replace('/', '%2F')}`
      : ''

    return await fetch(
      `${process.env.REACT_APP_API_PEDIDOS}api/venda-promovida?${codigoPromotor}${idPedido}${datainicial}${datafinal}${page}${pagesize}`,
      {
        method: 'get',
        headers: defaultOptions.headers
      }
    )
  },

  async GetDadosPagamentos(IdPedido) {
    var token = `${auth.token()}`
    var tokendecoded = jwt.decode(token)

    let paramPedido = !!IdPedido
      ? `idPedido=${IdPedido}&idCliente=${tokendecoded.id}`
      : ''

    return await fetch(
      `${process.env.REACT_APP_URL_MAIN}/pedidos/DadosPagamentoJson?${paramPedido}`,
      {
        method: 'GET'
      }
    ).then((response) => response.json())
  },

  async SalvarDadosPagamento(formData) {
    // return await fetch(
    //   `${process.env.REACT_APP_API_ENDPOINT}/pedidos/SalvarDadosPagamento`,
    //   {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(formData)
    //   }
    // )
    return await axios
      .post(
        `${process.env.REACT_APP_API_CHECKOUT}api/Pedido/SalvarDadosPagamento/`,
        formData
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export default pedidos

//mock codigo promotor 'RH097'
